@if (typeObj) {
    <div class="container bg-white mt-2 item-edit mb-5">
        <div>
            <h2 class="news__title">
                Resultaten vragenlijst
                <i class="fa fa-file-excel float-end curpoint" (click)="saveAsExcel()"></i>
            </h2>
            <h4 class="text-capitalize">{{ Routenames.news }}: {{ typeObj?.title }}</h4>
        </div>
        @if (answers?.length === 0) {
            <p>Deze vragenlijst is nog door niemand beantwoord.</p>
        }
        @if (typeObj.survey) {
            <div class="mt-5">
                <h4>Resultaten</h4>
                @if (questionGraphs) {
                    <div>
                        @for (graph of questionGraphs; track graph.question) {
                            <div class="mb-4">
                                <h6>
                                    {{ graph.question }}
                                </h6>
                                @if (graph.areaData) {
                                    <ngx-charts-area-chart
                                        [view]="view"
                                        [scheme]="colorScheme"
                                        [legend]="false"
                                        [showXAxisLabel]="true"
                                        [showYAxisLabel]="true"
                                        [xAxis]="true"
                                        [yAxis]="true"
                                        xAxisLabel="Score"
                                        yAxisLabel="Aantal"
                                        [tooltipDisabled]="true"
                                        [timeline]="false"
                                        [xAxisTicks]="graph.xAxisTicks"
                                        [yAxisTicks]="graph.yAxisTicks"
                                        [yAxisTickFormatting]="shortNumberPipe.transform"
                                        [results]="graph.areaData">
                                    </ngx-charts-area-chart>
                                }
                                @if (graph.pieData) {
                                    <ngx-charts-pie-chart
                                        [view]="view"
                                        [scheme]="colorScheme"
                                        [results]="graph.pieData"
                                        [gradient]="false"
                                        [legend]="false"
                                        legendPosition="right"
                                        [labels]="true"
                                        [doughnut]="false"
                                        [tooltipDisabled]="true">
                                    </ngx-charts-pie-chart>
                                }
                                @if (graph.barData) {
                                    <ngx-charts-bar-vertical
                                        [view]="view"
                                        [scheme]="graph.colorScheme ?? colorScheme"
                                        [results]="graph.barData"
                                        [gradient]="false"
                                        [xAxis]="true"
                                        [yAxis]="true"
                                        [legend]="false"
                                        [showXAxisLabel]="false"
                                        [showYAxisLabel]="true"
                                        [xAxisLabel]="null"
                                        [yAxisTicks]="graph.yAxisTicks"
                                        [yAxisTickFormatting]="shortNumberPipe.transform"
                                        yAxisLabel="Aantal">
                                    </ngx-charts-bar-vertical>
                                }
                            </div>
                        }
                    </div>
                }
                <div class="mt-5">
                    <h4>Antwoorden op vragenlijst</h4>
                    @for (question of typeObj.survey.questions; track question.hash) {
                        <div>
                            <h6 class="mt-3">
                                {{ question.question }}
                            </h6>
                            @if (question.type === 'open' || question.type === 'score') {
                                @for (answer of answers; track $index) {
                                    <div [class.mb-1]="question.type === 'open'">
                                        <span [class.txtbold]="question.type === 'open'">{{ answer.user.name }}:</span>
                                        {{ answer.answers[question.hash] }}
                                    </div>
                                }
                            }
                            @if (question.type === 'options') {
                                @for (option of question.options; track option) {
                                    <div class="answer">
                                        {{ option }}: {{ question.answers ? question.answers[option]?.join(', ') : '' }}
                                    </div>
                                }
                            }
                            @if (question.type === 'boolean') {
                                <div class="answer">
                                    Ja
                                    @if (question.limitCount) {
                                        ({{ question.totalCount }} / {{ question.limitCount }})
                                    }
                                    : {{ question.answers ? question.answers['Ja']?.join(', ') : '' }}
                                </div>
                                <div class="answer">
                                    Nee: {{ question.answers ? question.answers['Nee']?.join(', ') : '' }}
                                </div>
                            }
                            @if (question.type === 'boolean-quantity') {
                                <div class="mb-2 answer">
                                    <b>Ja ({{ question.totalCount }} / {{ question.limitCount }})</b>
                                </div>
                                <div>
                                    @if (question.answers) {
                                        <table class="table user-count">
                                            <tr>
                                                <th>Naam</th>
                                                <th>Aantal</th>
                                            </tr>
                                            @for (answer of question.answers['Ja']; track answer) {
                                                <tr>
                                                    <td>
                                                        {{ answer?.name }}
                                                    </td>
                                                    <td>
                                                        {{ answer?.quantity }}
                                                    </td>
                                                </tr>
                                            }
                                        </table>
                                    }
                                </div>
                                <div class="p-1 mt-5 answer">
                                    <b>Nee:</b>
                                    {{ question.answers ? question.answers['Nee']?.join(', ') : '' }}
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        }
        <button mat-flat-button color="primary" class="mt-5" (click)="navigateBack()">
            Terug naar {{ Routenames.news }}
        </button>
    </div>
    <div class="floating-buttons">
        <button (click)="delete()" color="primary" mat-fab>
            <mat-icon class="fas fa-trash"></mat-icon>
        </button>
        <button
            color="primary"
            mat-fab
            routerLink="/{{ Routenames.news }}/{{ typeObj.slug }}/{{ Routenames.survey }}/{{ Routenames.edit }}">
            <mat-icon class="fas fa-pencil-alt"></mat-icon>
        </button>
    </div>
}
